<app-dialog-wrapper>
  <div class="content">
    <app-textarea
      label="Any notes for the driver?"
      [rows]="5"
      [resizable]="true"
      [formControl]="noteControl"
    />
  </div>

  <div footer class="footer">
    <app-button
      [outline]="true"
      [size]="ButtonSize.Large"
      [style]="ButtonStyle.Danger"
      (buttonClick)="closeDialog()"
    >
      Cancel
    </app-button>

    <app-button
      [size]="ButtonSize.Large"
      (buttonClick)="closeDialog(this.noteControl.value)"
    >
      Save Note
    </app-button>
  </div>
</app-dialog-wrapper>
